/* The trigger spans its container; everything inside it is the vendor's geometry, reached through VendorSelect.base.vue. */
.root {
  width: var(--width-ds-full);
}
